import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import scriptLoader from 'react-async-script-loader'

const PaypalButton = ({ isScriptLoaded, isScriptLoadSucceed, ...props }) => {
    const [showButton, setShowButton] = useState(false)

    useEffect(() => {
        window.React = React
        window.ReactDOM = ReactDOM
    }, [])

    useEffect(() => {
        if (isScriptLoaded && isScriptLoadSucceed) {
            setShowButton(true)
        }
    }, [isScriptLoaded, isScriptLoadSucceed])

    if (!showButton) {
        return null
    }

    const Comp = window.paypal.Buttons.driver('react', {
        React,
        ReactDOM,
    })

    return <Comp {...props} />
}

export default (client, currency) =>
    scriptLoader(
        `https://www.paypal.com/sdk/js?client-id=${client || 'sb'}&currency=${
            currency || 'USD'
        }`
    )(PaypalButton)
